import { render, staticRenderFns } from "./cockpit.vue?vue&type=template&id=2ebb8870&scoped=true&"
import script from "./cockpit.vue?vue&type=script&lang=js&"
export * from "./cockpit.vue?vue&type=script&lang=js&"
import style0 from "./cockpit.vue?vue&type=style&index=0&id=2ebb8870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb8870",
  null
  
)

export default component.exports